import type { StageStatus } from "@gearbox-protocol/deploy-tools-shared";
import clsx from "clsx";
import type { FC } from "react";

const BG_COLORS: Record<StageStatus, string> = {
  queued: "bg-gray-300",
  success: "bg-green-600",
  error: "bg-red-600",
  failed: "bg-red-600",
  started: "bg-sky-400 animate-pulse",
};

interface StatusDotProps {
  status?: StageStatus;
  className?: string;
  size?: number;
}

const StatusDot: FC<StatusDotProps> = ({ status, className, size = 8 }) => {
  const color = status ? BG_COLORS[status] : "bg-gray-300";
  return (
    <div
      className={clsx("rounded-full", color, className)}
      style={{ width: `${size}px`, height: `${size}px` }}
    />
  );
};

export default StatusDot;
